import React from 'react';
import { personalInfo } from '../../data/portfolioData';

export const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();

  const handle = (event, path) => {
    event.preventDefault();
    onNavigate(path);
  };

  return (
    <footer className="footer">
      <p>
        &copy; {year} {personalInfo.name}
      </p>
      <nav className="footer-links" aria-label="Site">
        <a href="/privacy" onClick={(e) => handle(e, '/privacy')}>
          privacy
        </a>
        <a href="/terms" onClick={(e) => handle(e, '/terms')}>
          terms
        </a>
      </nav>
    </footer>
  );
};

export default Footer;
